export const getLicense = () => {
  return '07579EEE-13574B7D-98CCD718-5169CA9B'
}
